import '../../../plugins/polyfills/js/CustomEvent.js';

export default () => {
    var timer;
    var windowWidth = $(window).width();
    window.addEventListener('resize', event => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(
            () => {
                if ($(window).width() !== windowWidth) {
                    // fix for mobile devices - scrolling triggers resize events when the action bar disappears
                    windowWidth = $(window).width();
                    window.dispatchEvent(new CustomEvent('resized'));
                    $(window).trigger('resized');
                }
            },
            100,
            event
        );
    });
};
